<template>
	<el-drawer
		v-model="open"
		:before-close="saveCookies"
		direction="btt"
		:id="'cookiebanner'"
		:withHeader="false"
		:size="isMobile ? '200px' : '70px'"
		:show-close="false"
	>
		<template #default>
			<p>Diese Website verwendet nur Cookies, die technisch für die Nutzung notwendig sind.</p>

			<div class="button-panel">
				<TheButton @buttonclick="openDetailsDialog = true" type="default">Details</TheButton>
				<TheButton @buttonclick="saveCookies" type="danger">Zustimmen</TheButton>
			</div>
		</template>
	</el-drawer>

	<el-dialog
		v-model="openDetailsDialog"
		:title="'Cookies verwalten'"
		id="cookiedialog"
		:closeable="false"
		@close="saveCookies"
		:fullscreen="isMobile"
	>
		<p>Wir erfassen nur technisch notwendige Cookies für die Nutzung des Beschwerde-Tools.</p>
		<a href="https://werberat.at/show_4377.aspx#cookie" title="Cookies - werberat.at" target="_blank" class="link">
			Mehr Informationen zu Cookies finden Sie hier.
		</a>
		<TheBox title="Systemrelevante Cookies" :titleLevel="3">
			<template #boxheaderRight>
				<TheToggle :active="necessaryCookies" disabled />
			</template>
		</TheBox>

		<template #footer>
			<div class="button-panel">
				<TheButton type="danger" @buttonclick="saveCookies">Speichern</TheButton>
			</div>
		</template>
	</el-dialog>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import TheButton from './TheButton.vue';
import TheToggle from './TheToggle.vue';
import TheBox from './TheBox.vue';
import { useStore } from '../store';

export default defineComponent({
	name: 'CookieBanner',
	data() {
		return {
			open: true,
			openDetailsDialog: false,
			necessaryCookies: true,
		};
	},
	components: {
		TheButton,
		TheToggle,
		TheBox,
	},
	setup() {
		const store = useStore();
		const isMobile = computed(() => store.state.isMobile);

		return {
			isMobile,
		};
	},
	methods: {
		saveCookies() {
			localStorage.setItem('werberat-cookie-isset', 'true');
			this.open = false;
			this.openDetailsDialog = false;
		},
	},
	mounted() {
		let cookieInLocalStorage = localStorage.getItem('werberat-cookie-isset');
		if (cookieInLocalStorage && cookieInLocalStorage === 'true') {
			this.open = false;
		} else {
			this.open = true;
		}
	},
});
</script>

<style lang="scss">
@use '../scss/vars.scss' as *;

#cookiebanner {
	background-color: var(--el-color-lightgrey-3);
	color: #fff;

	.el-drawer__body {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		max-width: 1200px;
		margin: 0 auto;
		box-sizing: border-box;
		padding: 0.75rem;

		p,
		.button-panel {
			margin: 0;
		}
	}
}

#cookiedialog {
	.box__header {
		margin: 0;
	}
}

/* mobile styles */
@media screen and (max-width: $mobile_maxwidth) {
	#cookiebanner {
		.el-drawer__body {
			flex-direction: column;

			p {
				margin-bottom: 2em;
			}

			.button-panel,
			.el-button {
				width: 100%;
			}
		}
	}

	#cookiedialog {
		width: 100%;
		border-radius: 0;
		background-color: var(--el-color-lightgrey-1);
		padding: 0;

		.el-dialog__header {
			background-color: #fff;
			padding: 1rem;

			.el-dialog__title {
				font-size: 1rem;
			}

			.el-dialog__headerbtn {
				height: 100%;
			}
		}

		.el-dialog__body,
		.el-dialog__footer {
			padding: 0 1rem;
		}
	}
}
</style>
